import {
  Typography,
  Box,
  IconButton,
  Grid,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

type WelcomeProps = {
  firstName?: string;
  educationDetails: boolean;
  profile: boolean;
};

export default function GetStarted({
  educationDetails,
  profile,
}: WelcomeProps) {
  const navigate = useNavigate();

  return (
    <>
      {/* {!profile && !educationDetails && ( */}
      <BorderBox>
        <Typography className="Activity">Getting Started</Typography>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Grid container spacing={2}>
            {!profile && (
              <Grid item xs={12} md={6}>
                <CustomBox1>
                  <GreyBox>
                    <Box>
                      <Typography className="getUpdate">UPDATE</Typography>
                      <Typography className="getBody">
                        {"Personal Info"}
                      </Typography>
                    </Box>
                    <IconButton className="getting">
                      <OpenInNewIcon
                        onClick={() => navigate("/landing/profile")}
                      />
                    </IconButton>
                  </GreyBox>
                </CustomBox1>
              </Grid>
            )}
            {!educationDetails && (
              <Grid item xs={12} md={6}>
                <CustomBox>
                  <GreyBox>
                    <Box>
                      <Typography className="getUpdate">UPDATE</Typography>
                      <Typography className="getBody">
                        {"Education Details"}
                      </Typography>
                    </Box>
                    <IconButton className="getting">
                      <OpenInNewIcon
                        onClick={() => navigate("/landing/profile?tab=1")}
                      />
                    </IconButton>
                  </GreyBox>
                </CustomBox>
              </Grid>
            )}
          </Grid>
        </Box>
      </BorderBox>
      {/* )} */}
    </>
  );
}

const CustomBox = styled(Box)`
  background-color: white;
  padding: 5px 0px 5px 0px;
  border-radius: 7px;
  width: 100%;
`;
const CustomBox1 = styled(Box)`
  background-color: white;
  padding: 5px 0px 5px 0px;
  border-radius: 7px;
  margin-right: 10px;
`;
const GreyBox = styled(Box)`
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-radius: 7px;
  margin: 10px;
`;

const BorderBox = styled(Box)`
  // height: 100%;
  border: 2px solid white;
  border-radius: 3px;
  padding: 15px;
`;
